import React from "react";
import { getLocalStorage } from "../utils";
import { Navigate, useLocation } from "react-router-dom";
import {
  ADMIN_ROUTES,
  AGENT_ROUTES,
  BUILDER_ROUTES,
  SALES_ROUTES,
  USER_ROUTES,
} from "../constants/appRoutes";
import { LOCAL_STORAGE_KEYS } from "../constants";

interface IProps {
  children: any;
}

const PrivateRoute: React.FC<IProps> = ({ children }) => {
  const location = useLocation();
  const isAuthenticated = getLocalStorage(LOCAL_STORAGE_KEYS.ACCESS_TOKEN);

  const routes = () => {
    if (
      location.pathname.includes(ADMIN_ROUTES.ROOT) ||
      location.pathname.includes(AGENT_ROUTES.ROOT) ||
      location.pathname.includes(BUILDER_ROUTES.ROOT) ||
      location.pathname.includes(SALES_ROUTES.ROOT)
    ) {
      return ADMIN_ROUTES.LOGIN;
    } else {
      return USER_ROUTES.ROOT;
    }
  };

  return isAuthenticated ? children : <Navigate to={routes()} />;
};

export default PrivateRoute;
